import Base from './base';

export default class RewardPool extends Base {}
